module.exports = __webpack_public_path__ + "static/media/Emily Anderson Headshot_1676901212075.52d6f2df.png";